"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CultivationOfVenus = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var CultivationOfVenus = (function (_super) {
    __extends(CultivationOfVenus, _super);
    function CultivationOfVenus() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.CULTIVATION_OF_VENUS,
            cost: 18,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.VENUS],
            metadata: {
                cardNumber: 'Pf45',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 3 plants to raise Venus 1 step.', function (eb) {
                        eb.plants(3).startAction.venus(1);
                    }).br;
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.venus(1, 2),
                description: '1 VP for every 2 Venus tags you own.',
            },
        }) || this;
    }
    CultivationOfVenus.prototype.canAct = function (player) {
        return player.plants >= 3 && player.canAfford(0, { tr: { venus: 1 } });
    };
    CultivationOfVenus.prototype.action = function (player) {
        player.deductResource(Resources_1.Resources.PLANTS, 3);
        player.game.increaseVenusScaleLevel(player, 1);
        player.game.log('{0} spent 3 plants to raise the Venus level 1 step', function (b) { return b.player(player); });
        return undefined;
    };
    CultivationOfVenus.prototype.play = function () {
        return undefined;
    };
    CultivationOfVenus.prototype.getVictoryPoints = function (player) {
        return Math.floor(player.getTagCount(Tags_1.Tags.VENUS, true, false) / 2);
    };
    return CultivationOfVenus;
}(Card_1.Card));
exports.CultivationOfVenus = CultivationOfVenus;
